import Http from '../utils/http'
import store from 'store/index'

export const getAll = (params = {}) => {
    return Http.get('/parameters/packages', { params })
               .then(response => {
                   store.dispatch('setPackages', response.data)
               })
}

export const get = (id) => {
    return Http.get(`/parameters/packages/${id}`)
               .then(response => {
                   store.dispatch('savePackage', response.data)
               })
}

export const create = (payload) => {
    return Http.post(`/parameters/packages`, payload)
               .then(response => {
                   store.dispatch('savePackage', response.data)
               })
}

export const update = (id, payload) => {
    return Http.put(`/parameters/packages/${id}`, payload)
               .then(response => {
                   store.dispatch('savePackage', response.data)
               })
}

export const destroy = (id) => {
    return Http.delete(`/parameters/packages/${id}`)
               .then(() => {
                   store.dispatch('destroyPackage', id)
               })
}

export const toggle = (id, field) => {
    return Http.put(`/parameters/packages/${id}/${field}`)
               .then(response => {
                   store.dispatch('savePackage', response.data)
               })
}

export const getPackageProducts = (id) => Http.get(`/parameters/packages/${id}/products`)

export const storeProduct = (id, payload) => Http.post(`/parameters/packages/${id}/products`, payload)

export const destroyProduct = (id, packageId) => Http.delete(`/parameters/packages/${id}/products/${packageId}`)



// WEBPACK FOOTER //
// ./src/services/packages.js